import { ModalFooter } from '@chakra-ui/react';

export default function ChakraModalFooter({ children, ...props }) {
    return <ModalFooter {...props}>{children}</ModalFooter>;
}
